import React, { useState } from "react";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";
import AlertField from "./AlertField";
import PasswordField from "./PasswordField";

const ResetPasswordAdmin = () => {
  const axiosPrivate = useAxiosPrivate();
  const [alert, setAlert] = useState(null);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  const [values, setValues] = useState({
    email: "",
    new_password: "",
  });

  const inputs = [
    {
      id: 1,
      name: "email",
      type: "email",
      placeholder: "Enter user email",
      errorMessage: "Enter valid email.",
      label: "Email",
      required: true,
    },
    {
      id: 2,
      name: "new_password",
      type: "password",
      placeholder: "Enter new password",
      errorMessage:
        "Password should be 8-20 characters including 1 number and 1 special character!",
      label: "New Password",
      pattern: `^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,20}$`,
      required: true,
    },
  ];

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const onReset = async (e) => {
    e.preventDefault();
    try {
      await axiosPrivate.post("auth/password/admin/reset/", values);
      setValues({
        email: "",
        new_password: "",
      });
      showAlert("Password Resetted successfully.", "success");
    } catch (err) {
      if (!err?.response) {
        showAlert("No Server Response", "warning");
      } else if (err.response?.status === 404) {
        showAlert("User account not found.", "warning");
      } else {
        showAlert("Reset Failed", "warning");
      }
    }
  };

  return (
    <>
      <AlertField alert={alert} />
      <div className="pt-2 pb-4">
        <h2 className="text-center mb-4">Reset Password</h2>
        <form onSubmit={onReset}>
          <div className="d-flex flex-column align-items-center">
            {inputs.map((input) => (
              <PasswordField
                key={input.id}
                {...input}
                value={values[input.name]}
                onChange={onChange}
              />
            ))}
          </div>
          <div className="text-center mt-4">
            <button className="btn btn-primary">Reset Password</button>
          </div>
        </form>
      </div>
    </>
  );
};

export default ResetPasswordAdmin;
